<div
  [attr.aria-hidden]="ariaHidden"
  [evalScripts]="disableScriptEval"
  [style.height]="height"
  [style.width]="height"
  [inlineSVG]="fileName"
></div>
